// Packages Import
import { memo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarExport, GridToolbarDensitySelector } from "@mui/x-data-grid";
import moment from "moment";

// Project Components
import InfoTable from "../../UI/Table";
import { Code4ReportAction } from "../../../store/Code4Report/Code4Report-slice";
import ColoredTextField from "../../UI/ColoredTextField";

const columnsSettings = [
	{ field: "bom", headerName: "BOM", type: "text", minWidth: 50, flex: 0.7 },
	{ field: "rev", headerName: "REV", type: "text", minWidth: 50, flex: 0.2 },
	{ field: "bomPartsNum", headerName: "No. of Bom Parts", type: "text", minWidth: 50, flex: 0.2 },
	{ field: "bomDateLoad", headerName: "Date Bom Loaded", type: "text", minWidth: 50, flex: 0.4 },
	{ field: "inputDueDate", headerName: "Input Due Dt", type: "text", minWidth: 50, flex: 0.4 },
	{ field: "rptDeliveryDueDate", headerName: "Rpt. Delivery Due Date", type: "text", minWidth: 50, flex: 0.4 },
	{ field: "dateCompleted", headerName: "Date Completed", type: "text", minWidth: 50, flex: 0.4 },
	{ field: "liaison", headerName: "Liaison", type: "text", minWidth: 50, flex: 0.4 },
	{ field: "project", headerName: "Project", type: "text", minWidth: 50, flex: 0.4 },
	{ field: "division", headerName: "Division", type: "text", minWidth: 50, flex: 0.2 },
];

const Code4ReportTable = (props) => {
	const dispatch = useDispatch();
	const prevFilteredData = useSelector((state) => state.code4ReportState.prevFilteredData);
	const columnVisibility = useSelector((state) => state.code4ReportState.tableColumnVisibility);
	const selectedRows = useSelector((state) => state.code4ReportState.selectedRows);
	const projectTableData = useSelector((state) => state.code4ReportState.PROJECT_INFO_TABLE);
	const shouldAutoSelectCheckBox = useSelector((state) => state.code4ReportState.shouldAutoSelectCheckBox);
	const filteredData = useSelector((state) => state.code4ReportState.filteredData);

	// const handleOnRowClick = (params) => {
	// 	dispatch(Code4ReportAction.updateProjectIndex({ val: params.row.uid }));
	// };

	const ExtraProps = {
		sx: {
			"& .MuiDataGrid-columnHeaderTitle": {
				textOverflow: "clip",
				whiteSpace: "break-spaces",
				lineHeight: 1.3,
			},
			height: 533,
		},
		headerHeight: 105,
		columnVisibilityModel: { ...columnVisibility, __check__: true },
		onColumnVisibilityModelChange: (newModel) => {
			dispatch(Code4ReportAction.setColumnVisibility({ columnVisibility: newModel }));
		},
		selectionModel: selectedRows,
		onSelectionModelChange: (newSelectionModel) => {
			dispatch(Code4ReportAction.setSelectedRow(newSelectionModel));
		},
	};
	const customToolBar = () => (
		<>
			<ColoredTextField
				label="Selected Org"
				value={prevFilteredData.userOrg}
				focused
				autoComplete="off"
				sx={{
					width: "100px",
					mr: "4.8px",
				}}
				inputProps={{
					readOnly: true,
					sx: {
						height: "18px",
						textAlign: "center",
					},
				}}
				InputLabelProps={{
					shrink: true,
				}}
			/>
			<GridToolbarColumnsButton />
			<GridToolbarFilterButton />
			<GridToolbarDensitySelector />
			<GridToolbarExport
				printOptions={{
					disableToolbarButton: true,
				}}
				csvOptions={{
					fileName: `Projects_${prevFilteredData.userOrg}_${moment().format("YYYYMMDD")}`,
				}}
			/>
		</>
	);

	useEffect(() => {
		if (shouldAutoSelectCheckBox && filteredData.from_email && projectTableData.length > 0) {
			dispatch(Code4ReportAction.setSelectedRow(projectTableData.map((_val, i) => i)));
			dispatch(Code4ReportAction.setShouldAutoSelectCheckBox(false));
		}
	}, [dispatch, filteredData.from_email, projectTableData, shouldAutoSelectCheckBox]);

	return (
		<InfoTable
			columnsSettings={columnsSettings}
			rows={projectTableData}
			maxtableHeight={10}
			height={500}
			autoTableHeight={false}
			rowsPerPageOptions={[10, 50, 100]}
			pageSize={10}
			// handleOnRowClick={handleOnRowClick}
			// selectionType="row"
			checkboxSelection={true}
			customToolBar={customToolBar}
			ExtraProps={ExtraProps}
		/>
	);
};

export default memo(Code4ReportTable);
